<template>
  <div class="app-container">
    <wd-navbar class="tarbar">
      <div slot="left" class="middle" @click="$goHome">
        <wd-icon name="arrow-left" />
      </div>
      <div style="white-space: nowrap">
        <span style="white-space: nowrap">{{
          equipInfo.equipmentName || "--"
        }}</span>
      </div>
    </wd-navbar>
    <div class="top-timer">
      <wd-datetime-picker
        v-if="check == '1'"
        class="group-picker-cell-icon atomic-no-border"
        @confirm="conform"
        type="date"
        :key="1"
        v-model="date"
        label=""
        placeholder="请选择日期"
      >
        <template #label>
          <span>选择日期</span>
          <img
            style="width: 1.5em; height: 1.5em"
            src="~@/assets/img/icon-calendar.png"
            alt=""
          />
        </template>
      </wd-datetime-picker>

      <wd-datetime-picker
        v-if="check == '2'"
        class="group-picker-cell-icon atomic-no-border"
        @confirm="conform"
        type="year-month"
        :key="2"
        v-model="date"
        label=""
        placeholder="请选择月份"
      >
        <template #label>
          <span>选择日期</span>
          <img
            style="width: 1.5em; height: 1.5em"
            src="~@/assets/img/icon-calendar.png"
            alt=""
          />
        </template>
      </wd-datetime-picker>
      <wd-datetime-picker
        v-if="check == '3'"
        class="group-picker-cell-icon atomic-no-border"
        @confirm="conform"
        type="year-month"
        :key="3"
        v-model="date"
        label=""
        placeholder="请选择年份"
        :display-format="displayFormat"
      >
        <template #label>
          <span>选择日期</span>
          <img
            style="width: 1.5em; height: 1.5em"
            src="~@/assets/img/icon-calendar.png"
            alt=""
          />
        </template>
      </wd-datetime-picker>
    </div>
    <div class="dater-picker">
      <wd-radio-group
        class="labelGroup"
        @change="checkChange"
        v-model="check"
        shape="button"
      >
        <wd-radio value="1">日</wd-radio>
        <wd-radio value="2">月</wd-radio>
        <wd-radio value="3">年</wd-radio>
      </wd-radio-group>
    </div>
    <div class="chart-container">
      <div class="echarts" id="echarts"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: "",
      check: "1",
      selectDate: "",
      equipInfo: {},
      displayFormat(items) {
        return `${items[0].label}`;
      },
      params: {
        startDate: "",
        endDate: "",
        nodeId: "",
      },
      chartsData: {
        time: [],
        data: [],
      },
    };
  },
  created() {
    this.date = new Date(
      this.$moment().subtract(1, "days").format("YYYY-MM-DD")
    );
    this.selectDate = this.$moment(this.date).format("YYYY-MM-DD");
    this.equipInfo = this.$route.params;
  },
  mounted() {
    if (!this.equipInfo.id) {
      this.$router.push("/power");
    } else {
      this.params.nodeId = this.equipInfo.id;
      this.getData();
    }
  },
  methods: {
    getData() {
      this.handleSearchDate();
      this.chartsData = {
        time: [],
        data: [],
      };
      // 进行http请求
      this.$http
        .get("/external/bill/getUsageListByNodeId", { params: this.params })
        .then((res) => {
          if (res.code == 200) {
            if (res.data && res.data.length > 0) {
              res.data.forEach((item, index) => {
                this.chartsData.time.push(item.sname);
                this.chartsData.data.push(item.usage);
              });
            }
            this.initEcharts();
          }
        });
    },
    initEcharts() {
      let that = this;
      let echarts = this.$echarts.init(document.getElementById("echarts"));
      let option = {
        color: [
          "#123dac",
          "#73e2e2",
          "#ff7e85",
          "#9b52ff",
          "#fac524",
          "#46caff",
          "#a1e867",
          "#10b2b2",
          "#ec87f7",
          "#f4905a",
          "#00baba",
          "#facf24",
          "#e89d67",
          "#23c6c6",
          "#fa8699",
          "#40b7fc",
          "#006d75",
          "#595959",
          "#f4764f",
          "#a640fc",
          "#fda23f",
          "#2d7ae4",
          "#5092ff",
          "#9351ed",
          "#8a89fe",
          "#df89e8",
          "#2797ff",
          "#6ad089",
          "#7c92e8 ",
        ],
        title: {
          text:
            this.check == "1"
              ? "日用电统计图"
              : this.check == "2"
              ? "月用电统计图"
              : this.check == "3"
              ? "年用电统计图"
              : this.equipInfo.equipmentName,
          left: "3%",
          top: "0%",
          textStyle: {
            fontSize: 14,
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: "18%",
          bottom: "16%",
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: that.chartsData.time,
          axisLabel: {
            color: "#a0a9bc",
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#a0a9bc",
            inside: true,
            margin: 0,
            verticalAlign: "bottom",
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "",
            data: that.chartsData.data,
            type: "line",
            smooth: true,
            smoothMonotone: "x",
            cursor: "pointer",
            showSymbol: false,
            lineStyle: {
              color: "rgba(24, 144, 255,1)",
            },
            areaStyle: {
              color: "rgba(207, 222, 255,.7)",
            },
          },
        ],
      };
      // 处理axisLabel
      option.xAxis.axisLabel.formatter = (value) => {
        console.log("value", value);
        let timerUnit =
          this.check == "1"
            ? "点"
            : this.check == "2"
            ? "日"
            : this.check == "3"
            ? "月"
            : "";
        let text = `${value.slice(0, -1)}\n${timerUnit}`;
        return text;
      };
      echarts.setOption(option);
    },
    checkChange(value) {
      this.handleDate(value);
      this.getData();
    },
    handleDate(value) {
      if (value == "1") {
        this.selectDate = this.$moment(this.date).format("YYYY-MM-DD");
      } else if (value == "2") {
        this.selectDate = this.$moment(this.date).format("YYYY-MM");
      } else if (value == "3") {
        this.selectDate = this.$moment(this.date).format("YYYY");
      }
    },
    conform(value) {
      if (this.check == "1") {
        this.selectDate = this.$moment(value).format("YYYY-MM-DD");
      } else if (this.check == "2") {
        this.selectDate = this.$moment(value).format("YYYY-MM");
      } else if (this.check == "3") {
        this.selectDate = this.$moment(value).format("YYYY");
      }
      this.getData();
    },
    handleSearchDate() {
      if (this.check == "1") {
        this.params.startDate = this.selectDate;
        this.params.endDate = this.selectDate;
      } else if (this.check == "2") {
        let d = new Date(
          Number(this.selectDate.split("-")[0]),
          Number(this.selectDate.split("-")[1]),
          0
        );
        let day = d.getDate();
        this.params.startDate = this.selectDate + "-01";
        this.params.endDate = this.selectDate + "-" + day;
      } else if (this.check == "3") {
        this.params.startDate = this.selectDate + "-01-01";
        this.params.endDate = this.selectDate + "-12-31";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.top-timer {
  box-shadow: 0 0 7px 0px rgba(57, 107, 219, 0.3);
  margin-bottom: 20px;
}
.labelGroup {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 30px;
  ::v-deep .wd-radio {
    margin-right: 0;
    .wd-radio__label {
      border-width: 0px;
      border-radius: 3px;
      padding: 3px 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 5px 0px rgba(173, 181, 189, 0.3);
    }
  }
  ::v-deep .wd-radio.is-checked {
    .wd-radio__label {
      font-weight: bold;
      // color: #fff;
      background-color: #cfdeff;
    }
  }
}

.echarts {
  width: 100vw;
  height: 300px;
}
</style>
